// import moment from '@/plugins/moment';
import { toCamelCaseProperties } from '@fixit/utils';

export default class ProductOrder {
	constructor(args) {
		args = toCamelCaseProperties(args) || {};
        this.orderId = args.orderId || 0
        this.createdTime = args.createdTime || ''
        this.totalPrice = args.totalPrice || 0
        this.orderStatusId = args.orderStatusId || ''
        this.salonName = args.salonName || ''
        this.productsOrdered = args.productsOrdered || 0
	}

	assign(order) {
		Object.assign(this, toCamelCaseProperties(order));
	}
}

//OrderStatusTypes
//''
//'New'
//'Picked-visit'
//'FinishedPicking'
//'ReadyForShipment'
//'Sent'
//'Delivered'
//'NewReturn'
//'ReturnChecked'
//'Credited'
//'Cancelled'
